import React from 'react';
import sokMap from '../../images/sok-project-map.png';


const AboutProject = () => {
    return (
        <div className="d-flex flex-wrap  width100" style={{ margin: '20px 0 20px 40px', padding: '0 20px', backgroundColor: 'white' }}>
            <div style={{ borderBottom: '2px solid #6fc05d' }} className="text-center width100">
                <h1>Projekat SoK</h1>
                <label style={{ color: '#0074a8' }}>Sinergija znanja i novo zapošljavanje u konkurentnim MSP</label>
            </div>
            <div style={{ marginTop: '30px' }}>
                <p className="font-size-17rem" >Program "Norveška za vas" finansijski je podržao realizaciju projekta SoK.</p>
                <p className="font-size-17rem">Projekat realizuju partneri:</p>
                <ul className="company-services-list">
                    <li className="font-size-17rem">- Vojvodina Metal Cluster, Temerin</li>
                    <li className="font-size-17rem">- ENECA Nis <a href="https://eneca.org.rs/">https://eneca.org.rs/</a></li>
                    <li className="font-size-17rem">- Udruženje stručnih radnika socijalne zaštite Republike Srbije, Beograd
                    <a href="http://www.udruzenjesz.rs/"> http://www.udruzenjesz.rs/</a>
                    </li>
                </ul>
            </div>
            <div>
                <h4 style={{ marginTop: '20px', marginBottom: '10px' }}>Cilj Projekta</h4>
                <p className="font-size-17rem">Poboljšati poslovne performanse (tržišni potencijal, održivost i konkurentnost) i
                poboljšati mogućnosti novog zapošljavanja u MSP-malim i srednjim preduzećima
                    metalskog/mašinskog sektora u ciljanim opštinama / gradovima 3. i 4. grupe razvijenosti U Srbiji.</p>
            </div>
            <div>
                <h4 style={{ marginTop: '20px', marginBottom: '10px' }}>Krajnji korisnici</h4>
                <ul className="company-services-list">
                    <li className="font-size-17rem">- MSP u metalskom/mašinskom sektoru u Srbiji</li>
                    <li className="font-size-17rem">- nezaposlena lica - mladi ljudi, žene, dugoročno nezaposleni i dr.</li>
                    <li className="font-size-17rem">- pripadnici marginalizovanih društvenih grupa</li>
                </ul>
            </div>

            <div style={{ height: 'fit-content' }}>
                <h4 style={{ marginTop: '20px', marginBottom: '10px' }}>Ciljane opštine/gradovi</h4>
                <p className="font-size-17rem">Aleksinac, Trstenik, Brus, Kraljevo, Prokuplje, Kuršumlija, Boljevac,
                    Ćuprija, Paraćin, Svrljig, Blace, Žitorađe, Soko Banja, Knjaževac i Despotovac</p>
                <img style={{ width: '80%', height: '80%', marginTop: '20px' }} alt="sok" src={sokMap}></img>
            </div>
            <div>
                <h4 style={{ marginTop: '20px', marginBottom: '10px' }}>Očekivani rezultati</h4>
                <ul className="company-services-list">
                    <li className="font-size-17rem">
                        Р1. Umrežena / udružena mala i srednja preduzeca u metalnom sektoru
                        iz ciljanih opština i gradova u najznačajniju nacionalnu asocijaciju metala u Srbiji- Vojvodina Metal Cluster
                        </li>
                    <li className="font-size-17rem">
                        Р2. Povećanje konkurentnosti MSP kroz implementaciju programa unapređenja "K: E-kvalitet je naš epitet"
                        </li>
                    <li className="font-size-17rem">
                        P3. Nezaposlena lice - mladi ljudi, žene, dugoročno nezaposleni i dr.
                        pripremljeni i obrazovani za moderan pristup i ulazak na tržiste rada i zapošljavanje.
                        </li>
                </ul>
            </div>
            <div>
                <h4 style={{ marginTop: '20px', marginBottom: '10px' }}>Direktni efekti i korist za udruženje MSP</h4>
                <ul className="company-services-list">
                    <li className="font-size-17rem">2. Besplatno učešce na poslovnim susretima sa potencijalnim kupcima / partnerima sa min. 40 kompanija</li>
                    <li className="font-size-17rem">1. udruživanje u najznacajniju nacionalnu asocijaciju metalaca u Srbiji, Kancelarija Niš</li>
                    <li className="font-size-17rem">3. Besplatna obuka za interne proverivače sistema kvaliteta ISO</li>
                    <li className="font-size-17rem">4. Besplatno uvodjenje jednog od neophodnih ISO standarda</li>
                    <li className="font-size-17rem">5. Besplatno učesće u programu podrške za razvoj i komercijalizaciju inovacija "VMC - Inovativni pull"
                        </li>
                    <li className="font-size-17rem">6. Besplatno učešće u programu podrške poslavanju MSP - "VMC Biznis klinika"
                        </li>
                    <li className="font-size-17rem">7. Besplatna obuka za zavarivače prema stvarnim potrebama konkretnih kompanija
                        </li>
                    <li className="font-size-17rem">8. Besplatna obuka za CNC operatere prema stvarnim potrebama konkretnih kompanija
                        </li>
                    <li className="font-size-17rem">9. Besplatan trening za poslodavce u domenu društvene odgovornosti i rada sa zaposlenima
                    iz društveno osetljivih grupa
                        </li>
                </ul>
            </div>
            <div>
                <h4 style={{ marginTop: '20px', marginBottom: '10px' }}>Direktni efekti i korist za nezaposlena lica</h4>
                <ul className="company-services-list">
                    <li className="font-size-17rem">1. Besplatna obuka za moderan i efikasan pristup trzištu rada</li>
                    <li className="font-size-17rem">2. Besplatne obuke za interne proverivače sistema kvaliteta, zavarivače i CNC operatere
                        </li>
                    <li className="font-size-17rem">3.Mogućnost novog zaposlenja</li>
                </ul>
            </div>
            <div>
                <h4 style={{ marginTop: '20px', marginBottom: '10px' }}>Očekivani efekti od koristi široj drustvenoj zajednici (opštinama/gradovima)</h4>
                <p className="font-size-17rem">Ova inovativna partnerska akcija tri respektabilne organizacije za podršku MSP
                koje deluju na nacionalnom nivou, će doprineti uravnoteženju socio-ekonomskog
                razvoja u Srbiji poboljšanjem poslovnog okruženja i potencijala lokalnih preduzeca
                u nerazvijenim područjima u cilju novog zapošljavanja i socijalne inkluzije
                marginalizovanih društvenih grupa.
                    </p>
            </div>
            <div style={{ marginTop: '20px' }} className="width100">
                <h5 style={{ marginBottom: '10px' }}>Vreme trajanja projekta</h5>
                <p className="font-size-17rem">Oktobar 2020 – Avgust 2021</p>
            </div>
            <div style={{ marginTop: '20px', marginBottom: '10px' }} className="width100">
                <h5 style={{ marginBottom: '10px' }}>Vrednost projekta</h5>
                <p className="font-size-17rem color-secondary">103,911.00 USD</p>
            </div>
        </div>
    )
}

export default AboutProject
